import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX, FiGift, FiDownload } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <motion.header 
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="fixed top-0 w-full bg-white/90 backdrop-blur-md border-b border-rose-primary/10 z-50"
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-rose-primary to-rose-secondary rounded-xl flex items-center justify-center">
              <SafeIcon icon={FiGift} className="text-white text-xl" />
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-rose-primary to-rose-secondary bg-clip-text text-transparent">
              Gifter's Choice
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-gray-700 hover:text-rose-primary transition-colors">Features</a>
            <a href="#how-it-works" className="text-gray-700 hover:text-rose-primary transition-colors">How It Works</a>
            <a href="#download" className="text-gray-700 hover:text-rose-primary transition-colors">Download</a>
          </nav>

          {/* Download Button */}
          <div className="hidden md:flex items-center space-x-4">
            <motion.a
              href="https://apps.apple.com/us/app/gifters-choice/id6755495960"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-gradient-to-r from-rose-primary to-rose-secondary text-white px-6 py-2 rounded-full font-medium flex items-center space-x-2 shadow-lg hover:shadow-xl transition-all"
            >
              <SafeIcon icon={FiDownload} className="text-sm" />
              <span>Download</span>
            </motion.a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 hover:text-rose-primary transition-colors"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="text-2xl" />
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="md:hidden mt-4 py-4 border-t border-rose-primary/10"
          >
            <nav className="flex flex-col space-y-4">
              <a href="#features" className="text-gray-700 hover:text-rose-primary transition-colors">Features</a>
              <a href="#how-it-works" className="text-gray-700 hover:text-rose-primary transition-colors">How It Works</a>
              <a href="#download" className="text-gray-700 hover:text-rose-primary transition-colors">Download</a>
              <a
                href="https://apps.apple.com/us/app/gifters-choice/id6755495960"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-rose-primary to-rose-secondary text-white px-6 py-2 rounded-full font-medium text-center"
              >
                Download App
              </a>
            </nav>
          </motion.div>
        )}
      </div>
    </motion.header>
  );
};

export default Header;